class CarouselCollections extends HTMLElement {
  constructor() {
      super();
  }

  connectedCallback() {
      this.initializeBlazeSlider();
  }

  initializeBlazeSlider() {
      const blazeSlider = this.querySelector('.carousel-collections__slider');

      if (!blazeSlider) return;

      const slider = new BlazeSlider(blazeSlider, {
          all: {
              transitionDuration: 300,
              transitionTimingFunction: 'cubic-bezier(0.45, 0.1, 0.45, 0.5)',
              slidesToShow: 1.3,
              slidesToScroll: 1,
              slideGap: 'clamp(0.8rem, 0.83333vw, 1.6rem)',
              loop: false,
              enablePagination: true,
          },
          '(min-width: 768px)': {
              slidesToShow: 2.2,
          },
          '(min-width: 1024px)': {
              slidesToShow: 2.6,
          },
          '(min-width: 1440px)': {
              slidesToShow: 3.2,
          }
      });

      const prevBtn = this.querySelector('.carousel-collections__prev');
      const nextBtn = this.querySelector('.carousel-collections__next');

      // Set initial disabled state
      this.updateButtonStates(0, slider);

      if (prevBtn) {
          prevBtn.addEventListener('click', () => slider.prev());
      }
      
      if (nextBtn) {
          nextBtn.addEventListener('click', () => slider.next());
      }

      // Listen for slide changes to update button states
      slider.onSlide((slide, firstVisibleSlide) => {
          this.updateButtonStates(slide, slider);
      });

      
  }

  updateButtonStates(currentSlide, slider) {
      const prevBtn = this.querySelector('.carousel-collections__prev');
      const nextBtn = this.querySelector('.carousel-collections__next');
      
      if (prevBtn && nextBtn) {
          // Disable prev button on first slide
          if (currentSlide === 0) {
              prevBtn.setAttribute('disabled', 'true');
          } else {
              prevBtn.removeAttribute('disabled');
          }
          
          // Disable next button on last slide
          if (currentSlide >= slider.states.length - 1) {
              nextBtn.setAttribute('disabled', 'true');
          } else {
              nextBtn.removeAttribute('disabled');
          }
      }
  }
}

customElements.define('carousel-collections', CarouselCollections);